/**
 * 新手引导教程配置
 */

export const TUTORIAL_TYPES = {
  RECEIVE_CODE: 'receiveCode', // 数据共享教程
  RECHARGE: 'recharge' // 充值教程
}

export const tutorialSteps = {
  // 数据共享教程步骤
  [TUTORIAL_TYPES.RECEIVE_CODE]: [
    {
      id: 'receive-step-1',
      target: '.project-search-input',
      title: 'tutorial.receiveCode.step1.title',
      content: 'tutorial.receiveCode.step1.content',
      placement: 'bottom',
      highlightPadding: 10,
      order: 1
    },
    {
      id: 'receive-step-2',
      target: '.project-search-input',
      title: 'tutorial.receiveCode.step2.title',
      content: 'tutorial.receiveCode.step2.content',
      placement: 'bottom',
      highlightPadding: 10,
      order: 2
    },
    {
      id: 'receive-step-3',
      target: '.project-search-input',
      title: 'tutorial.receiveCode.step3.title',
      content: 'tutorial.receiveCode.step3.content',
      placement: 'bottom',
      highlightPadding: 10,
      order: 3
    },
    {
      id: 'receive-step-4',
      target: '.project-search-input',
      title: 'tutorial.receiveCode.step4.title',
      content: 'tutorial.receiveCode.step4.content',
      placement: 'bottom',
      highlightPadding: 10,
      order: 4
    },
    {
      id: 'receive-step-5',
      target: '.get-number-btn',
      title: 'tutorial.receiveCode.step5.title',
      content: 'tutorial.receiveCode.step5.content',
      placement: 'bottom',
      highlightPadding: 10,
      order: 5
    },
    {
      id: 'receive-step-6',
      target: '.phone-number-section',
      title: 'tutorial.receiveCode.step6.title',
      content: 'tutorial.receiveCode.step6.content',
      placement: 'top',
      highlightPadding: 10,
      order: 6
    }
  ],

  // 充值教程步骤
  [TUTORIAL_TYPES.RECHARGE]: [
    {
      id: 'recharge-step-1',
      target: '.recharge-btn-trigger', // 充值按钮
      title: 'tutorial.recharge.step1.title',
      content: 'tutorial.recharge.step1.content',
      placement: 'bottom',
      highlightPadding: 10,
      order: 1,
      requireAction: true,
      actionType: 'openRecharge'
    },
    {
      id: 'recharge-step-2',
      target: '.recharge-tabs',
      title: 'tutorial.recharge.step2.title',
      content: 'tutorial.recharge.step2.content',
      placement: 'bottom',
      highlightPadding: 10,
      order: 2,
      waitForDialog: true // 等待对话框打开
    },
    {
      id: 'recharge-step-3',
      target: '.usdt-amount-selector',
      title: 'tutorial.recharge.step3.title',
      content: 'tutorial.recharge.step3.content',
      placement: 'bottom',
      highlightPadding: 10,
      order: 3
    }
  ]
}

export const TUTORIAL_STORAGE_KEY = 'tq_tutorial_completed'

/**
 * 获取已完成的教程列表
 */
export function getCompletedTutorials() {
  try {
    const completed = localStorage.getItem(TUTORIAL_STORAGE_KEY)
    return completed ? JSON.parse(completed) : []
  } catch (error) {
    console.error('获取已完成教程失败:', error)
    return []
  }
}

/**
 * 标记教程为已完成
 */
export function markTutorialCompleted(tutorialType) {
  try {
    const completed = getCompletedTutorials()
    if (!completed.includes(tutorialType)) {
      completed.push(tutorialType)
      localStorage.setItem(TUTORIAL_STORAGE_KEY, JSON.stringify(completed))
    }
  } catch (error) {
    console.error('保存教程状态失败:', error)
  }
}

/**
 * 检查教程是否已完成
 */
export function isTutorialCompleted(tutorialType) {
  const completed = getCompletedTutorials()
  return completed.includes(tutorialType)
}

/**
 * 重置所有教程状态（用于测试）
 */
export function resetAllTutorials() {
  try {
    localStorage.removeItem(TUTORIAL_STORAGE_KEY)
  } catch (error) {
    console.error('重置教程状态失败:', error)
  }
}

/**
 * 重置特定教程状态
 */
export function resetTutorial(tutorialType) {
  try {
    const completed = getCompletedTutorials()
    const index = completed.indexOf(tutorialType)
    if (index > -1) {
      completed.splice(index, 1)
      localStorage.setItem(TUTORIAL_STORAGE_KEY, JSON.stringify(completed))
    }
  } catch (error) {
    console.error('重置教程状态失败:', error)
  }
}
